'use es6';

import * as Actions from 'FormsUI/actions/FormDragDrop';
const INIT_STATE = {
  draggedItem: null
};
export function formDragDrop(state = INIT_STATE, action) {
  switch (action.type) {
    case Actions.SET_DRAGGED_ITEM:
      return Object.assign({}, state, {
        draggedItem: action.draggedItem
      });
    default:
      return state;
  }
}